import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ChartLines = ({chartData, title}) => {
    if (chartData == undefined || chartData.length == 0) {
      return
    }

	//막대그래프
	const optionsLine = {
		chart: {
			type: 'bar'
		},
		title: {
			text: title,
			style: {
				color: '#000',
				fontSize: "14px",
				fontWeight: "bold",
			}
		},
		xAxis: {
			categories: chartData[0].cat,
			title: {
				text: null
			}
		},
		yAxis: {
			min: 0,
			title: {
				align: 'high'
			},
			labels: {
				overflow: 'justify'
			}
		},
		tooltip: {
			valueSuffix: ' 원'
		},
		plotOptions: {
			bar: {
				dataLabels: {
					enabled: true
				}
			}
		},
		legend: {
			layout: 'vertical',
			align: 'right',
			verticalAlign: 'bottom',
			x: 0,
			y: -50,
			floating: true,
			borderWidth: 1,
			backgroundColor: Highcharts.defaultOptions.legend.backgroundColor || '#FFFFFF',
			shadow: false
		},
		credits: {
			enabled: false
		},
		series: chartData,
		accessibility: {
			enabled: false
		},
	}

	return (
		<>
			<HighchartsReact highcharts={Highcharts}
				options={optionsLine}
			/>
		</>
	);
};

export default ChartLines;